import React, { useMemo } from "react";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";
import useQuery from "../../../hooks/useQuery";
import { getOrganisationsApi } from "../../../services/apis/organisationApis";
import Button from "../../../components/FormComponents/Button";
import ButtonActionIcon from "../../../components/BuilderComponents/ButtonActionIcon";

const STATUS_OPTIONS = [
  { label: "All Statuses", value: "" },
  { label: "Released", value: "RELEASED" },
  { label: "Rejected", value: "REJECTED" },
  { label: "Promoted", value: "PROMOTED" },
  { label: "Awaiting Approval", value: "AWAITING_APPROVAL" },
  { label: "Awaiting Promotion", value: "AWAITING_PROMOTION" },
  { label: "Failed", value: "FAILED" }
];

const ORG_LIST = ["organisations-list"];

const ReleaseFilters = ({ filters, onFilterChange, onToggleRelease, onRefresh }) => {
  const { data: orgsResponse } = useQuery(ORG_LIST, getOrganisationsApi);
  const organisations = useMemo(() => orgsResponse?.data || [], [orgsResponse]);

  const orgOptions = useMemo(() => {
    return organisations.map((org) => ({ label: org.name, value: org.id }));
  }, [organisations]);

  const appOptions = useMemo(() => {
    if (!filters.org_id) return [];
    const selectedOrg = organisations.find((org) => org.id === filters.org_id);
    return selectedOrg?.apps?.map((app) => ({ label: app.name, value: app.id })) || [];
  }, [organisations, filters.org_id]);

  const handleOrgChange = (option) => {
    onFilterChange({
      ...filters,
      org_id: option?.value || "",
      app_id: "" // Reset app when org changes
    });
  };

  const handleAppChange = (option) => {
    onFilterChange({
      ...filters,
      app_id: option?.value || ""
    });
  };

  const handleStatusChange = (option) => {
    const val = option?.value || "";
    onFilterChange({ ...filters, status: val });
  };

  return (
    <div className="d_flex justify_between gap_3 pt_3">
      <div className="d_flex align_center gap_2">
        {/* Organization Filter */}
        <div className="d_flex align_center gap_2" style={{ minWidth: "200px" }}>
          <div className="flex_grow">
            <SingleSelectBox
              label="Org"
              options={orgOptions}
              selectedData={filters.org_id}
              valueKey="value"
              labelKey="label"
              onChange={handleOrgChange}
              placeholder="Select Org"
              size="small"
              containerClassName="w_100"
            />
          </div>
        </div>

        {/* Application Filter */}
        <div className="d_flex align_center gap_2" style={{ minWidth: "200px" }}>
          <div className="flex_grow">
            <SingleSelectBox
              label="App"
              options={appOptions}
              selectedData={filters.app_id}
              valueKey="value"
              labelKey="label"
              onChange={handleAppChange}
              placeholder="Select App"
              size="small"
              containerClassName="w_100"
              disabled={!filters.org_id}
              containerStyle={!filters.org_id ? { opacity: 0.5, pointerEvents: "none" } : {}}
            />
          </div>
        </div>

        <div className="d_flex align_center gap_2" style={{ minWidth: "200px" }}>
          <div className="flex_grow">
            <SingleSelectBox
              label="Status"
              options={STATUS_OPTIONS}
              selectedData={filters.status}
              valueKey="value"
              labelKey="label"
              onChange={handleStatusChange}
              placeholder="Select Status"
              size="small"
            />
          </div>
        </div>
      </div>

      <div className="d_flex align_center gap_2">
        <ButtonActionIcon
          type="refresh"
          size="md"
          onClick={onRefresh}
          title="Refresh Instances"
          style={{ height: "32px", width: "32px" }}
        />
        <Button variant="secondary" onClick={onToggleRelease} style={{ height: "32px" }}>
          New Release
        </Button>
      </div>
    </div>
  );
};

export default ReleaseFilters;
